export const locale = {
  lang: 'en',
  data: {
    'Tabs': {
      'Offer': 'Offer',
      'BasicDetail': 'Basic Detail',
      'File': 'File',
      'Category': 'Category',
      'WorkItem': 'Work Item'
    },
    'TITLE': {
      'CustomerPagination': 'Antal log pr. side',
    },
    'MESSAGE': {
      'Failed': 'Operation failed , try later',
      'Success': 'Success.',
      'CommingSoon': 'Comming Soon..',
      'Deleted': 'Deleted successfully',
      'Added': 'Created successfully',
      'Updated': 'Updated successfully',
      'NORECORD': 'No defect rooms found',
    },
    'FIELDS': {
      'GoTo': 'Go to',
      'Moisture': 'Moisture %',
      'Temperature': 'Temperature ℃',
      'SRNO': 'Sr No',
      'Status': 'Status',
      'Number': 'Number',
      'Name': 'Name',
      'Createdby': 'Created By',
      'CreatedDate': 'Created Date',
      'ModifyBy': 'Modify By',
      'ModifyDate': 'Modify Date',
      'CoworkerName': 'Coworker',
      'Date': 'Date',
      'Description': 'Description',
      'Action': 'Action',
      'ModuleName': 'Module',
      'ByCoworker': 'by co-worker',
      'ByCustomer': 'by customer',
      'All': 'All',
      'RoomName': 'Room Name',
      'Text': 'Text',
      'SelectRoom': 'Select Room',
      'DragAndDropFile':'Drag and drop file here',
      'Or':'Or',
      'BrowseForFile':'Browse for file',
    },
    'BUTTONS': {
      'Add': 'Add'
    },
    'Headers': {
      'DeleteDefectRoom': 'Do you want to delete defect room',
      'UploadFile': 'Upload File',
      'ChooseFile': 'Choose File',
      'ChoosePicture': 'Choose Picture',
    },
    'VALIDATIONS': {
      'Rooms': 'Select at least one room',
      'Text': 'Text is required',
      'Image': 'File is required'
    }
  }
};
